import { NavLink } from "react-router-dom";

export default function SettingsPage() {
    return (
        <div className="card">
            <h2 className="card-title">Settings</h2>

            <div className="settings-grid">
                <NavLink to="/settings/brands" className="settings-tile">
                    <span className="tile-icon">🏷️</span>
                    <div>
                        <h4>Brands & Models</h4>
                        <p>Manage brands and their models</p>
                    </div>
                </NavLink>
            </div>
        </div>
    );
}
